import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';
import { AssortmentDTO, ExpireAssortmentItemsDTO } from '@retail/my-assortment/types';
import { useMPEFetch, useMutateMPEFetch } from '@retail/app/hooks';
import { mpeApi } from '@retail/mgpris/config';

interface Props extends QueryOptions {
  orgUnitId: number;
}

export function useFetchOrgUnitAssortments({ orgUnitId, ...queryOptions }: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<AssortmentDTO[]>({
    method: 'GET',
    queryKey: ['orgUnit-assortments'],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.orgUnits.orgUnit.assortments.getFullLinkPath({ orgUnitId }),
    }),
    ...queryOptions,
  });
}

export interface ExpireAssortmentItemsUrlVariables {
  assortmentId: number;
  shouldDeleteForChildren?: boolean;
}

export function useMutateExpireAssortmentItems(queryOptions: QueryOptions = {}) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<void, ExpireAssortmentItemsDTO, ExpireAssortmentItemsUrlVariables>({
    method: 'POST',
    url: ({ assortmentId }) =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.assortments.assortment.items.expire.getFullLinkPath({ assortmentId }),
      }),
    token,
    ...queryOptions,
  });
}
